// --- Core ---
import {map} from "underscore";
// --- SaniQ ---
import {
  DeserializedRecord,
  deserializeItem,
  deserializeManyRelationship,
  Deserializer,
  deserializeSingleRelationship,
  JSONAPIManyRelationship,
  JSONAPIRecord,
  JSONAPISingleRelationship
} from "./Helpers";
import {Contact} from "./Contact";
import {Information} from "./Information";
import {VitalDatum} from "./Patient";

type MessageAuthorType = "Patient" | "Patient::Measurement" | "Patient::Trigger" | "Physician" | "VideoConsultation";
type MessageRecipientType = "Patient" | "Patient::Measurement";

interface ChatPatient extends DeserializedRecord<"patient"> {
  customPatientId?: string;
  inactive: boolean;
  contacts: Contact[];
  information: Information;
  pausedAt?: Date;
  pausedEndAt?: Date;
  vitalDatum: VitalDatum;
}

interface Chat extends DeserializedRecord<"chat"> {
  messages: Message[];
  patient: ChatPatient;
  unreadCount: number;
}

interface Message extends DeserializedRecord<"message"> {
  authorId: number;
  authorType: MessageAuthorType;
  readAt: Date;
  receipientId: number;
  receipientType: MessageRecipientType;
  text: string;
}

const deserializeMessage = deserializeItem<Message>;

interface ChatPatientData extends JSONAPIRecord {
  relationships: {
    contacts: JSONAPIManyRelationship;
    information: JSONAPISingleRelationship;
    patient_vital_datum: JSONAPISingleRelationship;
  } & JSONAPIRecord["relationships"];
}

const deserializePatient: Deserializer<ChatPatient, ChatPatientData> = (data, included) => {
  const contacts = deserializeManyRelationship<Contact>(data.relationships.contacts, included);
  const information = deserializeSingleRelationship<Information>(data.relationships.information, included);
  const vitalDatum = deserializeSingleRelationship<VitalDatum>(data.relationships.patient_vital_datum, included);

  return {
    ...deserializeItem(data),
    contacts,
    information,
    vitalDatum
  };
};

interface ChatData extends JSONAPIRecord {
  attributes: {
    messages: JSONAPIManyRelationship;
  } & JSONAPIRecord["attributes"];
  relationships: {
    patient: JSONAPISingleRelationship;
  } & JSONAPIRecord["relationships"];
}

const deserializeChat: Deserializer<Chat, ChatData> = (data, included) => {
  const messages = map(data.attributes.messages.data, deserializeMessage).reverse();
  const patient = deserializeSingleRelationship(data.relationships.patient, included, deserializePatient);

  return {
    ...deserializeItem(data),
    messages,
    patient
  };
};

export {
  Chat,
  ChatPatient,
  deserializeChat,
  deserializeMessage,
  Message,
  MessageAuthorType
};
